import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Router, Route } from 'react-router-dom';
import { AppContainer } from 'react-hot-loader';
import DUI from 'dui';
import { createBrowserHistory } from "history";
import Root from './Router';

import "bootstrap-scss/bootstrap.scss";

const history = createBrowserHistory({ basename: CONFIG.BASENAME });
const { SocialLoginHeader, BaseFooter } = DUI.Components;

const render = (Component) => {
  ReactDOM.render(
    <AppContainer>
      <div>
        <SocialLoginHeader />
        <BrowserRouter basename={CONFIG.BASENAME}>
          <Router history={history}>
            <Route path="/" component={Component} key="index" />
          </Router>
        </BrowserRouter>
        <BaseFooter />
      </div>
    </AppContainer>,
    document.getElementById('root')
  );
};

render(Root);
